import React from 'react';
import CustomCard from './../../../../../components/CustomCard';
import {
    AccessDevicesTitle,
    IconPlusFill,
    IconUserAuthority,
    PhoneLight,
} from '../../../../../components/buttons/IconButtons';
import { MOBILE_ROLES_MODEL, SPECIAL_PERMISSIONS, WEBSITE_ROLES_MODEL } from '../Model/AllowedModules';
import SummaryTable from './SummaryTable';
import NotInformation from '../../../../../components/NotInformation';
import SummarySection from '../../../../../components/Summary/SummarySection';
import DivContainerBody from '../../../../../components/DivContainerBody';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const Summary = ({ t, selectedPermissions, roleName, selected, roleListData }) => {
    const buildModules = (model, isMobile) =>
        model
            .map((module) => {
                const modulePermissions = (selectedPermissions || [])
                    .map((selected) => roleListData?.find((r) => r.id === selected.id))
                    .filter(
                        (role) =>
                            role &&
                            role.isMobileApp === isMobile &&
                            module.children?.some((child) => child.id === role.moduleId),
                    );

                const normalPermissions = modulePermissions.filter(
                    (permission) => !SPECIAL_PERMISSIONS.includes(permission.name),
                );

                const specialPermissions = modulePermissions.filter((permission) =>
                    SPECIAL_PERMISSIONS.includes(permission.name),
                );

                return {
                    ...module,
                    modulePermissions,
                    normalPermissions,
                    specialPermissions,
                    permissionsCount: modulePermissions.length,
                };
            })
            .filter((module) => module.permissionsCount > 0);

    const groupedWebModules = buildModules(WEBSITE_ROLES_MODEL, false);
    const groupedMobileModules = buildModules(MOBILE_ROLES_MODEL, true);

    return (
        <div>
            <SummarySection icon={IconUserAuthority} title={t('details')}>
                <div className='row align-items-center m-3 gy-0'>
                    <div className='col-12 col-md-6 d-flex align-items-center gap-3 mb-3 mb-md-0 px-0 mx-0'>
                        <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center background-primary-100'>
                            <IconUserAuthority className='btn-icon-svg-24px' />
                        </div>
                        <div className='d-flex flex-column'>
                            <p className='fs-14px ibl-font-w-600 mb-1'>{t('name')}</p>
                            <p className='fs-16px ibl-font-w-300 mb-0'>{roleName}</p>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 d-flex justify-content-start'>
                        <CustomCard
                            classCard='border-radius-8px border-left-shades-300 background-shades-100 w-100'
                            classContent='pb-3 w-100 border-radius-8px'
                            classes='w-100 border-radius-8px'
                        >
                            <div className='d-flex align-items-center justify-content-between w-100'>
                                <p className='fs-14px ibl-font-w-600 font-color-text-950 mb-0'>
                                    {t('total_added_employees')}
                                </p>
                                <div className='d-flex align-items-center gap-2'>
                                    <IconPlusFill />
                                    <p className='fs-14px ibl-font-w-600 font-color-text-950 mb-0'>
                                        {selected?.length}
                                    </p>
                                </div>
                            </div>
                        </CustomCard>
                    </div>
                </div>
            </SummarySection>
            <SummarySection icon={AccessDevicesTitle} title={t('web')}>
                {groupedWebModules.length > 0 ? (
                    groupedWebModules.map((module) => {
                        const Icon = module.icon;

                        return (
                            <SummarySection
                                icon={Icon}
                                title={t(module.translation)}
                                rightHeader={
                                    <div className='ml-3 d-flex justify-content-center align-items-center border-radius-8px w-20px background-shades-200'>
                                        <p className='fs-14px ibl-font-w-500 mb-0 px-1'>{module.permissionsCount}</p>
                                    </div>
                                }
                            >
                                <div className='row align-items-start'>
                                    <div className='col-12 col-md-1 d-flex justify-content-center justify-content-md-start mb-3 mb-md-0 mt-90px'>
                                        <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center background-primary-100'>
                                            <Icon className='btn-icon-svg-24px' />
                                        </div>
                                    </div>

                                    <div className='col-12 col-md-11 px-3 pb-3 pt-2'>
                                        <div className='overflow-auto'>
                                            <SummaryTable
                                                module={module}
                                                roleListData={roleListData}
                                                selectedPermissions={selectedPermissions}
                                                t={t}
                                                platform='web'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </SummarySection>
                        );
                    })
                ) : (
                    <NotInformation text={t('you_havent_created_any_roles_yet')} card />
                )}
            </SummarySection>
            <SummarySection icon={PhoneLight} title={t('mobile')}>
                {groupedMobileModules.length > 0 ? (
                    groupedMobileModules.map((module) => {
                        const Icon = module.icon;

                        return (
                            <SummarySection
                                icon={Icon}
                                title={t(module.translation)}
                                rightHeader={
                                    <div className='ml-3 d-flex justify-content-center align-items-center border-radius-8px w-20px background-shades-200'>
                                        <p className='fs-14px ibl-font-w-500 mb-0 px-1'>{module.permissionsCount}</p>
                                    </div>
                                }
                            >
                                <div className='row align-items-start'>
                                    <div className='col-12 col-md-1 d-flex justify-content-center justify-content-md-start mb-3 mb-md-0 mt-90px'>
                                        <div className='p-8px border-radius-8px d-flex w-44px h-44px justify-content-center background-primary-100'>
                                            <Icon className='btn-icon-svg-24px' />
                                        </div>
                                    </div>

                                    <div className='col-12 col-md-11 px-3 pb-3 pt-2'>
                                        <div className='overflow-auto'>
                                        <SummaryTable
                                            module={module}
                                            roleListData={roleListData}
                                            selectedPermissions={selectedPermissions}
                                            t={t}
                                            platform='mobile'
                                        /></div>
                                    </div>
                                </div>
                            </SummarySection>
                        );
                    })
                ) : (
                    <NotInformation text={t('you_havent_created_any_roles_yet')} card />
                )}
            </SummarySection>
        </div>
    );
};
export default Summary;
